import { z } from 'zod';

/** Backend key shape: `pk_` or `sk_`, the mode, then 32 base64url characters. */
const PUBLISHABLE = /^pk_(live|test)_[A-Za-z0-9_-]{8,}$/;

/**
 * Only publishable keys: the API refuses a secret key whenever a browser `Origin` is present
 * (`SECRET_KEY_IN_BROWSER`), and a secret key has no business in a web page anyway.
 */
export const pasteKeySchema = z.object({
  key: z
    .string()
    .trim()
    .min(1, { error: 'docs:keys.paste.invalid' })
    .refine((key) => !key.startsWith('sk_'), { error: 'docs:keys.paste.secret', abort: true })
    .refine((key) => PUBLISHABLE.test(key), { error: 'docs:keys.paste.invalid' }),
});

export type PasteKeyValues = z.infer<typeof pasteKeySchema>;
